<template>
    <div
        :class="`head ${props.bottomBorderShow ? 'bottomBorder' : ''}`"
        @click.stop="mainClick"
        :style="`height: ${headHeight}px;`"
    >
        <el-icon
            :size="20"
            class="left-icon"
            v-if="props.leftShow"
            :style="`${iconColor ? `color:${iconColor}` : ''}`"
            @click.stop="leftIconClick"
        >
            <ArrowLeft/>
        </el-icon>
        <div
            :class="props.titleLeftShow ? 'centerTitle' : ''"
            :style="titleBold ? 'font-weight: bold;' : ''"
        >
      <span
          style="display: flex; align-content: center; justify-content: center"
      >
        <slot name="titleLeftIcon"></slot>
        {{ title }}
      </span>
        </div>
        <el-button :type="buttonType" :disabled="buttonDisable" :loading="loading" class="right-icon" v-if="buttonTitle"
                   @click="onButtonClick">{{
                buttonTitle
            }}
        </el-button>
        <el-icon
            :size="20"
            class="right-icon"
            v-if="props.rightShow"
            :style="`${iconColor ? `color:${iconColor}` : ''}`"
            @click.stop="rightIconClick"
        >
            <ArrowRight/>
        </el-icon>
    </div>
</template>
<script lang="ts" setup>
import {ref} from 'vue';

const props = defineProps({
    title: {
        type: String,
        default: undefined,
    },
    titleLeftShow: {
        type: Boolean,
        default: false,
    },
    titleBold: {
        type: Boolean,
        default: true,
    },
    leftShow: {
        type: Boolean,
        default: false,
    },
    rightShow: {
        type: Boolean,
        default: false,
    },
    buttonTitle: {
        type: String,
        default: undefined,
    },
    buttonType: {
        type: String,
        default: undefined
    },
    buttonDisable: {
        type: Boolean,
        default: false
    },
    headHeight: {
        type: Number,
        default: 50,
    },
    bottomBorderShow: {
        type: Boolean,
        default: false,
    },
    iconColor: {
        type: String,
        default: undefined,
    },
});

const emit = defineEmits([
    "leftIconClick",
    "rightIconClick",
    "mainClick",
    "onButtonClick",
]);

const loading = ref<boolean>(false)

function leftIconClick() {
    emit("leftIconClick");
}

function rightIconClick() {
    emit("rightIconClick");
}

function mainClick() {
    emit("mainClick");
}

function onButtonClick() {
    loading.value = true
    emit("onButtonClick");
    loading.value = false
}
</script>

<style lang="less">
.head {
    width: 100%;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;

    .left-icon {
        cursor: pointer;
        position: absolute;
        left: 10px;
    }

    .right-icon {
        cursor: pointer;
        position: absolute;
        right: 10px;
    }

    .centerTitle {
        position: absolute;
        left: 10px;
    }
}

.bottomBorder {
    cursor: pointer;
    border-bottom: 1px solid rgb(214, 215, 217);
}
</style>
